"use client";
import React, {useState, useEffect, useRef} from "react";
import {FontIcon} from "@/app/_components";
import styles from "./swiper.module.css";

type SwiperProps = {
    autoplay?: boolean;
    autoplayInterval?: number;
    children?: React.ReactNode;
    toggle?: boolean;
}

function Swiper(props: SwiperProps) {
    const {
        autoplay = false,
        autoplayInterval = 3000,
        toggle = false
    } = props;

    const [currIndex, setCurrIndex] = useState<number>(0);
    const timeoutRef = useRef<number | null>(null);
    const childLength = React.Children.count(props.children);

    function swiperNext() {
        console.log(11)
        setCurrIndex(prevIndex => {
            if (prevIndex === childLength - 1) {
                return 0
            }
            return prevIndex + 1
        });
    }

    function swiperPrev() {
        setCurrIndex(prevIndex => {
            if (prevIndex === 0) {
                return 0
            }
            return prevIndex - 1
        });
    }

    const runTimerSwiper = () => {
        // @ts-ignore
        timeoutRef.current = setTimeout(() => {
            swiperNext()
            runTimerSwiper()
        }, autoplayInterval);
    }

    useEffect(() => {
        if (!autoplay) return;

        runTimerSwiper();

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
    }, [])

    // 分页指示器
    let indicator: React.ReactNode = null,
        indicators = Array.from({length: childLength}, (_, i) => i);
    indicator = (
        <div className={styles.indicator_wrapper}>
            <div className={styles.indicator_box}>
                {indicators.map((item, i) => (
                    <div
                        className={
                            `${styles.indicator_dot} 
               ${currIndex === i ? styles.indicator_dot_active : ''}`
                        }
                        key={i}
                    >
                    </div>
                ))}
            </div>
        </div>
    )


    return (
        <div className={styles.swiper}>
            {toggle && <div className={styles.toggle_wrapper}>
                <div onClick={swiperPrev}>
                    <FontIcon icon="s-left" style={{fontSize: '.75rem'}}></FontIcon>
                </div>
                <div onClick={swiperNext}>
                    <FontIcon icon="s-right" style={{fontSize: '.75rem'}}></FontIcon>
                </div>
            </div>}

            <div className={styles.swiper_allow_touch_move}>
                <div className={styles.swiper_inner}>
                    {React.Children.map(props.children, (child, i) => {
                            if (React.isValidElement(child)) {
                                const cons = {
                                    // @ts-ignore
                                    activeIndex: currIndex,
                                    compIndex: i,
                                    lastIndex: childLength - 1
                                }
                                return React.cloneElement(child, cons);
                            }
                            return child;
                        }
                    )}
                    {/*{props.children}*/}
                </div>
            </div>

            {indicator}
        </div>
    )
}

type SwiperItemProps = {
    activeIndex?: number;
    compIndex?: number;
    lastIndex?: number;
    children?: React.ReactNode;
}
Swiper.Item = function (props: SwiperItemProps) {
    const {
        activeIndex = 0,
        compIndex = 0,
        lastIndex = 0
    } = props;
    // console.log(activeIndex, compIndex);

    let isStart = false;
    if (activeIndex > 0) isStart = true;

    const isLoopEnd = compIndex === 0 && activeIndex === lastIndex;
    if (isLoopEnd) console.log(compIndex);

    let compStyle: React.CSSProperties = {
        left: `-${compIndex * 100}%`,
        transition: "all 1s",
    }
    if (isLoopEnd) {
        compStyle.transition = 'none'
        compStyle.transform = 'translate3d(100%, 0, 0)'
    } else {
        compStyle.transform = `translate3d(-${100 * activeIndex}%, 0, 0)`
    }

    if (activeIndex === 0 && compIndex > 0) {
        compStyle.transition = 'none'
        compStyle.transform = `none`
    }

    return (
        <div
            className={`${styles.swiper_slide}`}
            style={compStyle}
        >
            {props.children}
        </div>
    )
}

export default Swiper;